declare namespace $ {

	type $mol_button_copy__title_shm_hitalama_map_widget_float_customdom_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customdom['error'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_dump_value__value_shm_hitalama_map_widget_float_customdom_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_customdom['result'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_customdom_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_customdom extends $shm_hitalama_map_widget_float {
		Dom_wrapper( ): any
		customdom_content( ): readonly(any)[]
		result( ): any
		error( next?: string ): string
		Copy_error( ): $mol_button_copy
		content( ): readonly(any)[]
		Dump( ): $mol_dump_value
		Error( ): $mol_view
	}
	
}

//# sourceMappingURL=customdom.view.tree.d.ts.map